const fetchError = (error) => {
  const err = new Error(error)

  throw new Error(`${err.name}: ${err.message}`)
}

const handleResponse = (response, callback) => {
  if (response.status >= 200 && response.status <= 299) {
    return response.json()
  }

  const error = new Error(`Error ${response.status}: ${response.statusText}`)

  callback ? callback(response) : fetchError(error)
  throw error
}

const fetchData = async (endpoint, callback = null) =>
  fetch(endpoint)
    .then((response) => handleResponse(response, callback))
    .catch((error) => {
      callback ? callback(error) : fetchError(error)
    })

const postData = async (endpoint, body, type = 'json', callback = null) =>
  fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: type === 'json' ? JSON.stringify(body) : body
  })
    .then((response) => handleResponse(response, callback))
    .catch((error) => {
      callback ? callback(error) : fetchError(error)
    })

export { fetchData, postData }
